import script from "./AlbumProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumProfile.vue?vue&type=script&setup=true&lang=js"

import "./AlbumProfile.vue?vue&type=style&index=0&id=7e9d903c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e9d903c"]])

export default __exports__